import { AfterContentInit, Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

/**
 * This directive allows attaching custom messages on validation error.
 *
 * { required: true } -> { required: true, message: 'Angiv din e-mail fx eksempel@mail.dk'}
 *
 * This helps to satisfy DKFDS guidelines (https://designsystem.dk/komponenter/fejlmeddelelser/)
 */
@Directive({
  selector: '[bomCustomValidationMessage]',
})
export class CustomValidationMessageDirective implements OnInit, OnDestroy, AfterContentInit {
  constructor(private control: NgControl) {}

  @Input() validationMsg: string;

  statusChangeSubscription: Subscription;

  ngAfterContentInit(): void {
    // Angular lifecycle causes validators to override appended .message values on init, without a change event,
    // so we need special handling when validator result has overridden our extended error object.

    // If control is invalid already on init, append .message to errors object
    if (this.control?.invalid) {
      this.setErrorMessage();
    }
  }

  ngOnInit(): void {
    this.formControlStatusChange();
  }

  formControlStatusChange() {
    if (
      this.validationMsg === undefined ||
      this.validationMsg === null ||
      this.validationMsg === ''
    ) {
      console.log('Use of `bomCustomValidationMessage` requires a `validationMsg` attribute');
    } else {
      this.statusChangeSubscription = this.control?.statusChanges.subscribe(status => {
        // When status changes to invalid, append .message to errors object
        if (status === 'INVALID') {
          this.setErrorMessage();
        }
      });
    }
  }

  setErrorMessage() {
    let errors = this.control.control.errors;
    if (!errors.message) {
      const messageError = { message: this.validationMsg };
      errors = { ...errors, ...messageError };
      this.control.control.setErrors(errors);
    }
  }

  ngOnDestroy() {
    this.statusChangeSubscription?.unsubscribe();
  }
}
